export default __webpack_public_path__ + "static/hover13-82c11d5370bfff872a39f81f505e4971.png";